
import React from 'react'

interface Props {
    saveItem: (key: string, value: string) => void,
    getItem: (key: string) => undefined | any,
    deleteItem: (key: string) => void,
}

export const isEmptyObject = (obj: any) => obj && Object.keys(obj).length === 0 && obj.constructor === Object

const useStorage = (): Props => {

    const saveItem = React.useCallback((key: string, value: string) => {
        localStorage.setItem(key, value)
    }, [])
    const getItem = React.useCallback((key: string): string | null => {
        return localStorage.getItem(key);
      }, []);
  
    const deleteItem = React.useCallback((key: string) => {
        localStorage.removeItem(key)
    }, [])

    return {
        deleteItem,
        getItem,
        saveItem
    }
}

export default useStorage
